import styled, { CSSObject } from "styled-components";
import { Label } from "semantic-ui-react";
import { Link } from "react-router-dom";

import { styledWithTheme } from "./theme";

import { definedAttachedLabelTypes } from "../components/atoms/Labels/AttachedLabel";

/**
 * Styled Link Card (basically every card)
 */
export const StyledLinkCard = styledWithTheme.div<{
  hover?: boolean;
  width?: string;
  maxwidth?: string;
  minwidth?: string;
  textAlign: CSSObject["textAlign"];
}>(({ width, maxwidth, minwidth, textAlign, hover, theme }) => ({
  "&&&": {
    display: "inline-block",
    width: `${width}`,
    maxWidth: `${maxwidth}`,
    minWidth: `${minwidth}`,
    textAlign,
    ":hover": hover
      ? {
          transform: "translateY(-3px)",
          boxShadow: theme.boxShadows.light,
        }
      : {},
  },
}));
export const StyledLinkCardLink = styled(Link)({
  "&&&": {
    position: "relative",
    zIndex: 1,
  },
});

/**
 * Attached Label on Event Image
 */
export const StyledAttachedLabel = styledWithTheme(Label)(
  ({ theme, type }) => ({
    "&&&": {
      marginBottom: "1em",
      marginLeft: "-0.5em",
      color: theme.palette.mono.white,
      backgroundColor: theme.palette.primary.main,
      borderRadius: "0",
      ...(type === definedAttachedLabelTypes.imageGallery && {
        marginLeft: "0",
        marginBottom: "0",
        marginTop: "1em",
        marginRight: "-0.5em",
        padding: "0.5em 1.5em",
        ".icon": {
          margin: "0",
        },
      }),
    },
  }),
);

export const StyledOrganizationCard = styledWithTheme.div(
  ({ theme, role }) => ({
    display: "grid",
    height: "100%",
    gridTemplateColumns: "15em 1fr 2em",
    backgroundColor: theme.palette.mono.lit,
    minHeight: "13em",
    alignItems: "center",
    "@media only screen and (max-width: 600px)": {
      gridTemplateColumns: "6em 1fr 2em",
      margin: "0.5em",
    },
    ":hover": {
      transform: role ? "translateY(-3px)" : "none",
      boxShadow: role ? theme.boxShadows.light : "none",
      cursor: role ? "pointer" : "default",
    },
    "#rightLink": {
      height: "100%",
    },
    "#red": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      backgroundColor: role
        ? `${theme.palette.primary.main}`
        : theme.palette.mono.lit,
      color: role ? "white" : theme.palette.mono.lit,
      i: {
        margin: 0,
      },
    },
    "#image": {
      padding: "2em",
      "@media only screen and (max-width: 600px)": {
        padding: "0.2em",
      },
    },
    "#content": {
      padding: "1em",
      "@media only screen and (max-width: 600px)": {
        fontSize: "1em",
      },
    },
    "#media": {
      textAlign: "right",
    },
  }),
);
